import React, { Component } from "react"
import I18n from "./i18n.js"
import ReactDOM from "react-dom"
import _ from 'underscore'
import FacetSelect2 from './facet_select2'
import createReactClass from 'create-react-class'
export default createReactClass({
  getDefaultProps() {
    return {
      options: {},
      min: '',
      max: '',
      className: ''
    };
  },

  createDropdown(key, options, value, enabledCB) {
    const placeholder = I18n.t('search.persons');
    const ref = `range_${key}`;
    const select_options = _.map(options, i => {
      return { value: i.value, label: i.display, disabled: !enabledCB(i.value) }
    });

    return <FacetSelect2
      placeholder={placeholder}
      name={ref}
      ref={ref}
      key={ref}
      value={value}
      options={select_options}
      onChange={() => this.props.onChange()}
      className={this.props.className}
    />
  },

  isMinEnabled(value) {
    if (!this.props.max) { return true; }
    if (value === '') { return true; }

    return value < this.props.max;
  },

  isMaxEnabled(value) {
    if (value === '') { return true; }
    if (!this.props.min) { return true; }

    return value > this.props.min;
  },

  render() {
    const min = this.createDropdown('min', this.props.options.min, this.props.min, this.isMinEnabled);
    const max = this.createDropdown('max', this.props.options.max, this.props.max, this.isMaxEnabled);

    return <div className="form-row range-selector">
      <div className="form-cell">{min}</div>
      <div className="form-cell">{max}</div>
    </div>;
  }
});
